<template>
  <div v-if="isShow" id="type-order">
    <div class="card">
      <div class="card-body">
        <div class="form-label mb-2 title">Тип заказа</div>
        <label class="form-check form-switch form-switch-3">
          <input class="form-check-input" type="checkbox" v-model="fields.firstOrder" @change="onChange">
          <span class="form-check-label">Первый заказ</span>
        </label>
        <label class="form-check form-switch form-switch-2">
          <input class="form-check-input" type="checkbox" v-model="fields.repeatOrder" @change="onChange">
          <span class="form-check-label">Повторный заказ</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue"
import "./css/style.css"

const props = defineProps({
  payload: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(["onChange"])

const isShow = ref(false)

const fields = reactive({
  firstOrder: false,
  repeatOrder: false,
})

onMounted(() => {
  updateFields(props.payload)
  isShow.value = true
})

function updateFields(query) {
  fields.firstOrder = query.first_order
  fields.repeatOrder = query.repeat_order
}

function onChange() {
  pushEvent(fields.firstOrder, fields.repeatOrder)
}

function pushEvent(firstOrder, repeatOrder) {
  emit("onChange", {
    first_order: firstOrder,
    repeat_order: repeatOrder,
  })
}
</script>

<style scoped></style>
